import { toast } from "@/components/ui/toast/toast";
import * as api from "./api";
import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query";
import { navigate } from "wouter/use-browser-location";

/*
 * useCreateSession Query
 *
 * Create a new session.
 * QueryKey: ["session"]
 */
export const useCreateSession = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: api.createSession,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["session"] });
    },
    onError: () => {
      toast({
        title: "Failed to create session.",
        type: "error",
      });
    },
  });
};

/*
 * useDeleteSession Query
 *
 * Delete the current session and redirect to the signout page.
 * QueryKey: ["session"]
 */
export const useDeleteSession = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: api.deleteSession,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["session"] });

      // Redirect to the signout page to clear any client-side state.
      navigate("/auth/signout", { replace: true });
    },
  });
};

/*
 * useGetSession Query
 *
 * Get the current session using a cookie for authentication.
 * QueryKey: ["session"]
 */
export const useGetSession = () => {
  return useQuery({
    queryKey: ["session"],
    queryFn: () => api.getSession(),
    select: (data) => data.payload.session,
  });
};
